import React, { useEffect, useRef } from 'react';
import { IoSettingsOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Avatar } from '@mui/material';
import { TbLogout } from 'react-icons/tb';
import { storePrivacyMode, setDisplayTheme } from 'store/reducers/mainSlice';

// ✅ Clear
const ClientProfileMenuBlock = ({ onCloseMenu, mainIconRef, mobile }) => {
    const [userFName, userLName, userEmail, profilePhoto] = useSelector((state) => [
        state.main?.user?.first_name,
        state.main?.user?.last_name,
        state.main?.user?.email,
        state.main?.user?.profile_photo_url
    ]);
    const [privacyMode, displayTheme] = useSelector((state) => [state.main.privacyMode, state.main.displayTheme]);


    const clientUser = useSelector((state) => state.main.client);

    const history = useNavigate();
    const dispatch = useDispatch();

    const menuRef = useRef(null);

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target) && mainIconRef.current && !mainIconRef.current.contains(event.target)) {
            onCloseMenu();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return (
        <div>
            <div className={`profile-details-dropdown pdb-container ${mobile ? 'profile-details-dropdown-mobile' : ''}`} ref={menuRef}>
                <div className="profile-details-dropdown-header">
                    <Avatar
                        sx={{ width: 35, height: 35 }}
                        style={{ fontSize: 8 }}
                        src={profilePhoto ? profilePhoto : 'https://cdn.iconscout.com/icon/free/png-256/free-avatar-380-456332.png'}
                    >
                        {userFName ? userFName?.[0] : ''}
                        {userLName ? userLName?.[0] : ''}
                    </Avatar>
                    <div className="profile-details-dropdown-header-name">
                        <h6>
                            {clientUser?.data?.company_name}
                        </h6>
                        <p>{clientUser?.data?.first_name} {clientUser?.data?.last_name}</p>
                    </div>
                </div>
                <div className="profile-details-dropdown-menu-items">
                    <div
                        className="profile-details-dropdown-menu-item"
                        onClick={() => {
                            history('client/settings');
                            onCloseMenu();
                        }}
                    >
                        <span className="pddmi-icon">
                            <IoSettingsOutline />
                        </span>
                        <span className="pddmi-text">Account Settings</span>
                        <span className="pddmi-action"></span>
                    </div>
                </div>
                <div className="profile-details-dropdown-footer">
                    <div className="profile-details-dropdown-menu-items">
                        <div
                            className="profile-details-dropdown-menu-item"
                            onClick={() => {
                                clientLogoutside();
                                setProfileActive(!profileActive);
                                onCloseMenu();
                            }}
                        >
                            <span className="pddmi-icon">
                                <TbLogout />
                            </span>
                            <span className="pddmi-text">Logout</span>
                            <span className="pddmi-action"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientProfileMenuBlock;
